if (typeof BABYLON === "undefined") { throw new Error("babylon.box3d.js needs babylon.js loaded first"); } module.exports = BABYLON;